module.exports = __webpack_public_path__ + "static/fonts/notokr-light.2ea9b0e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/font/notokr-light.woff
// module id = zOe3
// module chunks = 0